import formatISODuration from 'date-fns/formatISODuration';
import intervalToDuration from 'date-fns/intervalToDuration';
import add from 'date-fns/add';

const getIsoDuration = (seconds: number): string => {
  const startDate = new Date();
  const endDate = add(startDate, { seconds });

  return formatISODuration(intervalToDuration({ start: startDate, end: endDate }));
};

export default getIsoDuration;
